"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleDependency = void 0;
const Shape_1 = require("lincd/lib/shapes/Shape");
const package_1 = require("../package");
const npm_1 = require("../ontologies/npm");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
let ModuleDependency = class ModuleDependency extends Shape_1.Shape {
    //https://github.com/sindresorhus/semver-regex/blob/main/index.js
    get version() {
        return this.getValue(npm_1.npm.version);
    }
    set version(val) {
        this.setValue(npm_1.npm.version, val);
    }
    get packageName() {
        return this.getValue(npm_1.npm.packageName);
    }
    set packageName(val) {
        this.setValue(npm_1.npm.packageName, val);
    }
};
ModuleDependency.targetClass = npm_1.npm.ModuleDependency;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: npm_1.npm.version,
        required: true,
        maxCount: 1,
        //NOTE: had to comment this out cause it causes a PARSE ERROR in safari - and we're not using pattern yet anyway
        // pattern:
        //   /(?<=^v?|\sv?)(?:(?:0|[1-9]\d{0,9}?)\.){2}(?:0|[1-9]\d{0,9})(?:-(?:--+)?(?:0|[1-9]\d*|\d*[a-z]+\d*)){0,100}(?=$| |\+|\.)(?:(?<=-\S+)(?:\.(?:--?|[\da-z-]*[a-z-]\d*|0|[1-9]\d*)){1,100}?)?(?!\.)(?:\+(?:[\da-z]\.?-?){1,100}?(?!\w))?(?!\+)/gi,
    })
], ModuleDependency.prototype, "version", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: npm_1.npm.packageName,
        required: true,
        maxCount: 1,
    })
], ModuleDependency.prototype, "packageName", null);
ModuleDependency = __decorate([
    package_1.linkedShape
], ModuleDependency);
exports.ModuleDependency = ModuleDependency;
//# sourceMappingURL=ModuleDependency.js.map